import { AutoComplete, AutoCompleteSelectEvent } from 'primereact/autocomplete';
import React, { useState, useEffect } from 'react';
import { User } from '../../entities/User';
import { useAZUserSearch } from '../../services/AzService';
import SessionStorageService from '../../services/SessionStorageService';
import { TOKEN_TYPE } from '../../entities/Constants';
import { AzureUser } from 'src/entities/formTemplateDataType';
import { useMsal } from '@azure/msal-react';
import { graphRequest } from '../../security/authConfig';

const AzureUsersLookUpComponent = (
    { userList, callback}: 
    {userList?: User[]; callback: (newList: User[])=>void;}
) => {
    const { instance, accounts } = useMsal();
    const [search, setSearch] = useState<string>('');
    const [token, setToken] = useState<string>(null);
    const { users, error, loading } = useAZUserSearch(token, search);
    
    const acquireGraphToken = async () => {
        try {
            const account = instance.getActiveAccount() || accounts[0];
            if (!account) {
                return null;
            }

            const response = await instance.acquireTokenSilent({
                scopes: graphRequest.scopes,
                account: account
            });
            
            return response.accessToken;
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        const getToken = async () => {
            let storedToken = SessionStorageService.getAccessToken(TOKEN_TYPE.GRAPH);
            
            if (!storedToken) {
                storedToken = await acquireGraphToken();
            }
            
            setToken(storedToken);
        };

        if (accounts.length > 0) {
            getToken();
        }
    }, [accounts, instance]);

    const mapAzureUserToUser= (azuser: AzureUser) => {
        const user = new User();
        user.email = azuser.mail;
        user.firstName = azuser.givenName;
        user.lastName = azuser.surname;
        user.phoneNumber = azuser.businessPhones?.[0] || azuser.mobilePhone;
        user.title = azuser.jobTitle;
        user.displayName = azuser.displayName;
        user.userName = azuser.userPrincipalName;
        return user;
    }

    const addUser = (e: AutoCompleteSelectEvent) => {
        if (!userList) userList = [];
        const selectedUser = users.find(user => user.mail === e.value.mail);
        if (!selectedUser) return;
        if (userList.find(user => user.email?.toLowerCase() === selectedUser.mail?.toLowerCase())) {
            setSearch('');
            return;
        }
        const updated = [...userList.map(u => ({ ...u })), mapAzureUserToUser(selectedUser)];
        callback(updated);
        setSearch('');
    }

    return (
        <AutoComplete
            multiple
            forceSelection
            showEmptyMessage
            field="displayName"
            style={{ width: '100%' }}
            value={userList || []}
            suggestions={users}
            completeMethod={(e) => setSearch(e.query)}
            onChange={(e) => {
                // e.value is the current selected token array (after add/remove)
                callback(e.value);
            }}
            onSelect={addUser}
        />
    );
}

export default AzureUsersLookUpComponent;